import { UserAuthWrapper } from "redux-auth-wrapper";
import { redirectIfNotAuthenticated } from '../actions/user';

const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.user.data,
  redirectAction: redirectIfNotAuthenticated,
  wrapperDisplayName: 'UserIsAuthenticated'
});

export default UserIsAuthenticated;



/** WEBPACK FOOTER **
 ** ./src/security/UserIsAuthenticated.js
 **/